import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnchor = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.588 21.413C2.97933 21.8043 3.45 22 4 22H20C20.55 22 21.021 21.8043 21.413 21.413C21.8043 21.021 22 20.55 22 20V4C22 3.45 21.8043 2.97933 21.413 2.588C21.021 2.196 20.55 2 20 2H4C3.45 2 2.97933 2.196 2.588 2.588C2.196 2.97933 2 3.45 2 4V20C2 20.55 2.196 21.021 2.588 21.413ZM20 20H4V6H20V20ZM19 14H5V19H19V14Z"
	})
});
export default SvgAnchor;
